module.exports = __webpack_public_path__ + "linea-ecommerce-10.9b3d6789b2aa87ea4f5b.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-ecommerce-10.svg
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-ecommerce-10.svg
// module chunks = styles